export const languageIsoCode = (language: string): string => {
  const match = language.match(/^([a-z]{2})/gi);
  return match ? match[0] : '';
};
